import type { ComputedRef } from 'vue';
import { computed } from 'vue';
import { HYPERSWITCH_SUBSCRIPTION_SERVICE } from '../shared/utils/hyperswitchRail';

/**
 * Both Round rails answer `provider === 'round'`; only the subscription service tells them apart,
 * and the card form has to know before an intent exists which order to do things in.
 */
export function useHyperswitchRail(): ComputedRef<boolean> {
  const gatewayStore = useKegelGatewayStore();

  return computed(() => gatewayStore.subscriptionService === HYPERSWITCH_SUBSCRIPTION_SERVICE);
}
